import { createCloseButton as d } from "../../util/component-utils.js";
import { detectSwipe as c, DIRECTIONS as m } from "../../util/dom-utils.js";
import { _handleBrazeAction as u } from "../../Core/handle-braze-action.js";
import { logCardDismissal } from "../index.js";
import { Guid as p } from "../../../shared-lib/index.js";
export const TOP_IMPRESSION_DATA_ATTRIBUTE = "data-ab-had-top-impression";
export const BOTTOM_IMPRESSION_DATA_ATTRIBUTE = "data-ab-had-bottom-impression";
export function topHadImpression(t) {
  return null != t && !!t.getAttribute("data-ab-had-top-impression");
}
export function impressOnTop(t) {
  null != t && t.setAttribute("data-ab-had-top-impression", "true");
}
export function bottomHadImpression(t) {
  return null != t && !!t.getAttribute("data-ab-had-bottom-impression");
}
export function impressOnBottom(t) {
  null != t && t.setAttribute("data-ab-had-bottom-impression", "true");
}
export function markCardAsRead(t) {
  if (null != t) {
    const o = t.querySelectorAll(".ab-unread-indicator")[0];
    null != o && (o.className += " read");
  }
}
export function getCardId(t) {
  return t.getAttribute("data-ab-card-id");
}
export function _setImageAltText(t, o) {
  let e = "";
  t.title || t.description || (e = "Feed Image"), o.setAttribute("alt", e);
}
export function setCardHeight(t, o) {
  const e = o.querySelectorAll(".ab-image-area");
  let a,
    n = 0;
  e.length > 0 && (n = e[0].offsetWidth);
  for (const o of t)
    if (((a = o.T), a && o.imageUrl && "number" == typeof o.aspectRatio)) {
      const t = n / o.aspectRatio;
      t && (a.style.height = `${t}px`);
    }
}
export function cardToHtml(t, logCardClick, o, e = "ltr") {
  const a = document.createElement("div");
  (a.dir = e),
    (a.className = "ab-card ab-effect-card " + t._),
    t.id &&
      (a.setAttribute("data-ab-card-id", t.id), a.setAttribute("id", t.id)),
    a.setAttribute("role", "article"),
    a.setAttribute("tabindex", "0");
  let n = "",
    i = !1;
  t.url && "" !== t.url && ((n = t.url), (i = !0));
  const r = (e) => (markCardAsRead(a), i && (logCardClick(t), u(n, o, e)), !1);
  if (t.pinned) {
    const t = document.createElement("div");
    t.className = "ab-pinned-indicator";
    const o = document.createElement("i");
    (o.className = "fa fa-star"), t.appendChild(o), a.appendChild(t);
  }
  if (t.imageUrl && "" !== t.imageUrl) {
    const o = document.createElement("div");
    (o.dir = e), (o.className = "ab-image-area");
    const d = document.createElement("img");
    if (
      (d.setAttribute("src", t.imageUrl),
      (d.onload = () => {
        a.style.height = "auto";
      }),
      _setImageAltText(t, d),
      o.appendChild(d),
      (a.className += " with-image"),
      i && !t.S)
    ) {
      const t = document.createElement("a");
      t.setAttribute("href", n),
        (t.onclick = r),
        t.appendChild(o),
        a.appendChild(t);
    } else a.appendChild(o);
  }
  const s = document.createElement("div");
  if (((s.className = "ab-card-body"), (s.dir = e), t.dismissible)) {
    t.logCardDismissal = () => logCardDismissal(t);
    const o = d("Dismiss Card", void 0, t.dismissCard.bind(t), e);
    a.appendChild(o),
      c(s, m.U, (t) => {
        (a.className += " ab-swiped-left"), o.onclick(t);
      }),
      c(s, m.V, (t) => {
        (a.className += " ab-swiped-right"), o.onclick(t);
      });
  }
  let l = "",
    b = !1;
  if ((t.title && "" !== t.title && ((l = t.title), (b = !0)), b)) {
    const t = document.createElement("h1");
    if (
      ((t.className = "ab-title"),
      (t.id = p.W()),
      a.setAttribute("aria-labelledby", t.id),
      i)
    ) {
      const o = document.createElement("a");
      o.setAttribute("href", n),
        (o.onclick = r),
        o.appendChild(document.createTextNode(l)),
        t.appendChild(o);
    } else t.appendChild(document.createTextNode(l));
    s.appendChild(t);
  }
  const f = document.createElement("div");
  if (
    ((f.className = b ? "ab-description" : "ab-description ab-no-title"),
    (f.id = p.W()),
    a.setAttribute("aria-describedby", f.id),
    t.description && f.appendChild(document.createTextNode(t.description)),
    i)
  ) {
    const o = document.createElement("div");
    o.className = "ab-url-area";
    const e = document.createElement("a");
    e.setAttribute("href", n),
      t.linkText && e.appendChild(document.createTextNode(t.linkText)),
      (e.onclick = r),
      o.appendChild(e),
      f.appendChild(o);
  }
  s.appendChild(f), a.appendChild(s);
  const x = document.createElement("div");
  return (
    (x.className = "ab-unread-indicator"),
    t.viewed && (x.className += " read"),
    a.appendChild(x),
    (t.T = a),
    a
  );
}
